import React from "react";
import styles from "./footer.module.css";

const footer = () => {
  return (
    <footer className={styles.footer}>
      <div class={styles.copyright}>
        <center>
          © Apltizr 2020 All Rights Reserved
        </center>
      </div>
    </footer>
  );
};

export default footer;
